
// This is an auto generated file - do not edit!
// Swagger path: /api/Answer/export

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Export
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class AnswerExportApiService extends BaseApiService {
    
    post(_export: any, options = {}): Observable<Export> {
        return this._post<Export, any>(
            `/Answer/export`,
            _export,
            options
        );
    }
}
